module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bij7p2/media/FC-9781035855438.jpg?1732629343414",
      "alt": "This image is the cover for the book The Polish Neighbours"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Polish Neighbours\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Reading Dad’s poetry is like taking a walk through his life. It is easy to see there are demons, but there is beauty and love too. Beauty in memories of greyhounds, raging fires, the plight of Indigenous people, the complexities of religious beliefs, and recognising the power of other people’s life stories. I remember sitting in the back seat of his car, listening to him speak of Shakespeare and reciting sonnets verbatim. He spoke of Keats and Eliot, of Yeats and Poe, and Yevtushenko and I did my best to comprehend the images of tragedy, love and loss. And now, many years later, when I read Dad’s words, I think I understand them.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jim Hale\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jim Hale is a retired high school teacher who specialised in English literature. He taught for 40 years in country NSW and city schools, giving him an incredible range of life experiences. He wrote most of the poems included herein before he had a serious stroke and lost some of what he still wanted to write. He wrote the last eight poems while recovering from the stroke, though he does not recall writing them.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0